export const NotificationIcons = {
  Warning: 'WARNING',
  Information: 'INFORMATION',
  Question: 'QUESTION',
  Danger: 'DANGER'
};
